import type { MinimalContentStore } from '@/services/container';
import type { Libp2pBrowserPeer } from '@/net/peer';
import { computeCid } from './cid';
import { MeshLinkError } from '@/lib/result';

/** 通过中继内容协议（/meshlink/content/1.0.0）实现的 IContentStore（T04）。 */
export class RelayContentStore implements MinimalContentStore {
  constructor(private readonly peer: Libp2pBrowserPeer) {}

  async put(bytes: Uint8Array, mime: string): Promise<string> {
    const cid = computeCid(bytes);
    const ok = await this.peer.contentPut(cid, mime, bytes);
    if (!ok) throw new MeshLinkError('E_RELAY_UNAVAILABLE', '内容上传至中继失败');
    return cid;
  }

  async get(cid: string): Promise<Uint8Array | null> {
    const res = await this.peer.contentGet(cid);
    return res?.bytes ?? null;
  }

  async has(cid: string): Promise<boolean> {
    return this.peer.contentHas(cid);
  }
}

export default RelayContentStore;
